import React, { useState, useEffect, useRef } from 'react';
import classes from './GoogleLocation.module.scss';
import t from '@/utils/Language/UI-translations';
import PlaceAutocomplete from 'react-google-autocomplete';
import Form from 'react-bootstrap/Form';
import usePlacesService from 'react-google-autocomplete/lib/usePlacesAutocompleteService';
import useLocation from '@/hooks/useLocation';
import FindLocation from './FindLocation';

const AutoComplete = ({
  map,
  locationObject, // expected to be the standard location object OD stores in localStorage
  saveLocationFn,
  showFindLocation,
  afterSubmit,
  placeholder = 'Enter a location',
  defaultLocation,
  label,
  additionalClasses,
  elementId = 'planLocationSearch',
  ...props
}) => {
  const autoCompleteRef = useRef();
  const { placesService, placePredictions, getPlacePredictions, isPlacePredictionsLoading } = usePlacesService({
    apiKey: process.env.REACT_APP_GOOGLE
  });
  const { locationContext } = useLocation();
  const [, setOptions] = useState({ center: {} });
  const [place, setPlace] = useState();
  const saveLocation = saveLocationFn || locationContext.updateLocationByPlace;
  const location = locationObject || locationContext.location;
  const defaultLocationValue = typeof defaultLocation === 'undefined' ? locationContext.getLocation()?.locationName : defaultLocation;

  useEffect(() => {
    // If this is being displayed along with a Map UI, then we want to update the Map view according to input selection.
    if (place && typeof map !== 'undefined') {
      if (place?.geometry?.viewport) {
        map.fitBounds(place?.geometry?.viewport);
      } else {
        map.setCenter(place?.geometry?.location);
        map.setZoom(17);
      }
      props.addplace(place);
      autoCompleteRef.current?.blur();
    }
  }, [place]);

  useEffect(() => {
    // If something else updates the location value, then update the input field to reflect that
    const locationName = location?.locationName;
    autoCompleteRef.current.value = typeof locationName == 'undefined' ? '' : locationName;
  }, [location?.locationName]);

  const saveLocationWithLatLngs = (place) => {
    saveLocation(
      Object.assign(place, {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
        locationName: place.formatted_address
      })
    );
  };

  const handleSubmit = (e, place) => {
    e.preventDefault();
    if (!place) {
      if (placePredictions[0]?.place_id) {
        placesService?.getDetails(
          {
            placeId: placePredictions[0]?.place_id
          },
          (placeDetails) => {
            if (placeDetails) {
              saveLocationWithLatLngs(placeDetails);
              setPlace(placeDetails);
              const element = document.getElementById(elementId);
              element.value = placePredictions[0].description;
            }
          }
        );
      } else {
        return false;
      }
    } else {
      saveLocationWithLatLngs(place);
    }

    if (typeof afterSubmit === 'function') {
      afterSubmit(e);
    }
  };

  const handleSelected = (place) => {
    if (place?.address_components) {
      saveLocationWithLatLngs(place);
      setPlace(place);
    }
  };

  const setEmpty = () => {
    saveLocation(false);
  };

  const setState = (state = {}) => {
    setOptions((prevState) => {
      if (props.onClick && (state.lat || state.lng || state.zip || state.address)) {
        props.onClick(props.answerType, state);
      }

      return {
        ...prevState,
        ...state
      };
    });
  };

  return (
    <Form onSubmit={handleSubmit} className={classes.Autocomplete}>
      <Form.Group controlId="formBasicName">
        {label && <Form.Label>{label}</Form.Label>}
        {/* TODO error boundary when 3rd party libs are not loading */}
        <PlaceAutocomplete
          className={[`${classes.autoCompleteInputField} ${additionalClasses} ${props?.error ? classes.showError : ''}`]}
          id={elementId}
          ref={autoCompleteRef}
          placeholder={t(placeholder)}
          onChange={(evt) => {
            if (evt.target.value === '') {
              setEmpty();
            }
            getPlacePredictions({ input: evt.target.value, types: ['geocode'], componentRestrictions: { country: 'us' } });
          }}
          onPlaceSelected={(place) => handleSelected(place)}
          options={{
            types: ['geocode'],
            componentRestrictions: { country: 'us' }
          }}
          defaultValue={defaultLocationValue}
        />
        {showFindLocation && (
          <FindLocation setState={setState} saveLocationFn={saveLocationFn} additionalClasses={`${additionalClasses} ${classes.myCurrentLocation}`} />
        )}
      </Form.Group>
    </Form>
  );
};

export default AutoComplete;
